module.exports = __webpack_public_path__ + "media/images/horizontal-28cb42d00a08a3cb36676189f23d3733.png";